import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { BONUS_VALUE, OFFER_ANCHOR, PRICE, PRODUCT_NAME } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="border-b border-line bg-canvasAlt" data-id="element-52" data-mp="8571he3loxu7">
      <div className="mx-auto max-w-xl px-3 py-6 text-center sm:px-5" data-id="element-53" data-mp="m4ouk5nxix9d">
        <p className="font-display text-[0.62rem] font-bold uppercase tracking-[0.16em] text-danger" data-id="element-54" data-mp="m2vk0fa73sw3">
          Una última oportunidad
        </p>
        <p className="mx-auto mt-1.5 max-w-xl text-[0.8rem] leading-snug text-ink-muted" data-id="element-55" data-mp="vv1b7msmi6a8">
          Puedes seguir guardando videos sobre cerraduras, RFID, biometría y
          control de acceso sin saber qué deberías aprender primero. O puedes
          comenzar hoy a construir una nueva habilidad siguiendo una ruta
          organizada desde cero.
        </p>
        <h2 id="cierre" className="mt-1.5 font-display text-base font-extrabold leading-tight text-ink sm:text-xl" data-id="element-56" data-mp="zuij0mvivfik">
          No necesitas ser experto en control de acceso para empezar. Necesitas
          dar el primer paso.
        </h2>

        <Reveal className="mt-3 rounded-xl border-2 border-accent bg-surface p-4" data-id="element-57" data-mp="2m19htmezyqc5">
          <p className="flex items-center justify-center gap-1.5 font-display text-[0.8rem] font-black uppercase leading-tight text-cyan sm:text-sm" data-id="element-58" data-mp="2r2p1pb5fuqsy">
            <LockIcon size={14} className="flex-shrink-0" data-id="element-59" data-mp="302ltvmr1e7sr" />
            {PRODUCT_NAME}
          </p>
          <p className="mt-1 font-display text-[0.75rem] font-extrabold uppercase text-ink" data-id="element-60" data-mp="34tbyuyvjw8mx">
            6 Tomos + 5 Bonos
          </p>
          <p className="mt-1.5 text-[0.75rem] text-ink-muted" data-id="element-61" data-mp="39rdh5hl5k3xc">
            Valor de los bonos:{' '}
            <span className="line-through" data-id="element-62" data-mp="3esjbfjugnz8z">{BONUS_VALUE}</span>
          </p>
          <p className="mt-0.5 font-display text-3xl font-black leading-none text-accent sm:text-4xl" data-id="element-63" data-mp="3islffzno54rf">
            Hoy: {PRICE}
          </p>

          <CtaButton href={OFFER_ANCHOR} size="lg" className="mt-3" data-id="element-64" data-mp="1jov0vteyecdf">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>

          <p className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[0.68rem] font-semibold text-ink-muted" data-id="element-65" data-mp="1sgn9dykf3bfd">
            <span className="flex items-center gap-1" data-id="element-66" data-mp="1npoosmsebr6b">
              <ZapIcon size={12} className="text-cyan" data-id="element-67" data-mp="1no3wl3tk0kbm" />
              Acceso Inmediato
            </span>
            <span className="text-ink-subtle" data-id="element-68" data-mp="1xfqfzng1pppg">•</span>
            <span data-id="element-69" data-mp="1xeykecmg7rz6">Entrega Digital</span>
            <span className="text-ink-subtle" data-id="element-70" data-mp="1xi46rk3p0fr7">•</span>
            <span className="flex items-center gap-1" data-id="element-71" data-mp="2be7zta2tyi23">
              <ShieldCheckIcon size={12} className="text-success" data-id="element-72" data-mp="27dxrhqrkffk2" />
              Garantía de 7 Días
            </span>
          </p>
        </Reveal>
      </div>
    </section>;
}